import { EventEmitter } from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'


class RelationsService extends EventEmitter {
  get(filter, from, to){
    if (!from)
      from = 0;
    if (!to)
      to = 10;

    var data = {
      filter: filter,
      from: from,
      to: to
    }
    return TCVelikClient.PostRelative(`/api/relation/get`, data);
  }

  SaveRelations(items){

    var post = {
      Items: items
    };

    return TCVelikClient.PostRelative("/api/relation/Save", post);
  }

  DeleteRelation(id){
    var post = {
      Id: id
    }

    return TCVelikClient.PostRelative("/api/relation/Delete", post);
  }
}

export default new RelationsService();
